import { configure as configureWidget } from "instantsearch.js/es/widgets"
const today = Math.floor(new Date().getTime() / 1000)

export const siteConfigure = configureWidget({
  hitsPerPage: 6,
  distinct: true,
  facetingAfterDistinct: true,
  filters: `status:live AND (expires = 0 OR expires > ${today})`,
  attributesToSnippet: ['copy:50']
});
